
import { AvailabilityDirectShipResponse, GetAvailabilityExtendedParameter, GetLcInventoryParameter, GetProductAvailabilityParameter, LcInventoryResponse, PriceAvailabilityResponse } from "@dana/Handlers/ProductAvailabilityHandler";
import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";
import { getProductById } from "@insite/client-framework/Services/ProductServiceV2";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";


const applicablePartsUrl = "api/v2/dana/productAvailability";
const dropShipPartsUrl = "api/v1/dana/availabilityextended";
const lcInventorysUrl = "api/v1/dana/lcinventory";

export async function getProductAvailabilityResponse(parameter: GetProductAvailabilityParameter) {
    const { ...newParemeter } = parameter;
    try {
        const priceandavailabilityModel = await get<PriceAvailabilityResponse>(`${applicablePartsUrl}`, newParemeter as ApiParameter);
        return priceandavailabilityModel;
    } catch (error) {
        const priceandavailabilityModelError = {} as PriceAvailabilityResponse;
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            priceandavailabilityModelError.error = true;
            priceandavailabilityModelError.errorMessage = error.errorJson.message;
            return priceandavailabilityModelError;
        } if ("status" in error && error.status === 404 && error.errorJson && error.errorJson.message) {

            priceandavailabilityModelError.error = true;
            priceandavailabilityModelError.errorMessage = error.errorJson.message;
        }
        return priceandavailabilityModelError;
    }

}

export async function getDropshipAvailabilityResponse(parameter: GetAvailabilityExtendedParameter) {
    try {
        const priceandavailabilityModel = await post<GetAvailabilityExtendedParameter,AvailabilityDirectShipResponse>(`${dropShipPartsUrl}`, parameter);
        return priceandavailabilityModel;
    } catch (error) {
        return null;
    }

}

export async function getLcInventoryResponse(parameter: GetLcInventoryParameter) {
    try {
        const lcInventoryModel = await post<GetLcInventoryParameter,LcInventoryResponse[]>(`${lcInventorysUrl}`, parameter);
        return lcInventoryModel;
    } catch (error) {
        return null;
    }

}


export async function getProduct(id: string): Promise<ProductModel | { error: boolean; errorMessage: string }> {

    try {
        const product = await getProductById({ id,expand:['properties'] });
        return product;
    } catch (error) {
        return {
            error: true,
            errorMessage: error?.errorJson?.message ?? "Unknown error",
        };
    }
}
